/**
 * Representa os tipos de alvo para aplicação/remoção em lote de promoções.
 */
export enum EPromotionApplyTargetType {
  AllProducts,
  SelectedProducts,
  AllMeals,
  SelectedMeals,
  AllDrinks,
  SelectedDrinks,
  AllCombos,
  SelectedCombos,
}
